import Cookies from "js-cookie";
import { AUTH_STORAGE_KEY } from "@shared/config";

interface CookiesData {
  [key: string]: string | undefined;
}

export const saveCookiesData = (data: CookiesData): void => {
  for (const key in data) {
    if (data.hasOwnProperty(key) && data[key] !== undefined) {
      Cookies.set(key, data[key]);
    }
  }
};

export const readCookie = (cookieKey: string) => {
  return Cookies.get(cookieKey);
};

export const deleteAllCookies = () => {
  const cookies = Cookies.get();

  for (const cookie in cookies) {
    Cookies.remove(cookie);
  }
};

export const getAuthKey = (): string | undefined => {
  return localStorage.getItem(AUTH_STORAGE_KEY) || undefined;
};

export const isAuthenticated = (): boolean => {
  const authKey = getAuthKey();
  return authKey === "true";
};

export const getSessionId = (): string | undefined => {
  return readCookie("sessionId");
};

export const isSessionActive = (): boolean => {
  const sessionId = getSessionId();
  return !!sessionId;
};
